/** A simple woven basket. */
export function Basket({ size = 150, className }) {
  return (
    <svg width={size} height={size * 0.8} viewBox="0 0 150 120" className={className} aria-hidden focusable="false">
      {/* body */}
      <path d="M20 36 C20 36 30 104 38 110 C50 117 100 117 112 110 C120 104 130 36 130 36 C110 49 40 49 20 36Z" fill="#DDA15E" />
      {/* weave */}
      <g stroke="#B5762E" strokeWidth="3" opacity="0.55">
        <path d="M38 52 C60 60 90 60 112 52" fill="none" />
        <path d="M42 74 C62 81 88 81 108 74" fill="none" />
        <path d="M47 95 C63 100 87 100 103 95" fill="none" />
        <path d="M55 44 L62 112" fill="none" />
        <path d="M75 47 L75 116" fill="none" />
        <path d="M95 44 L88 112" fill="none" />
      </g>
      {/* rim */}
      <ellipse cx="75" cy="36" rx="58" ry="14" fill="#E9B872" />
      <ellipse cx="75" cy="32" rx="58" ry="13" fill="#F0C68A" />
      <ellipse cx="75" cy="34" rx="58" ry="13" fill="none" stroke="#B5762E" strokeWidth="5" opacity="0.5" />
    </svg>
  );
}

export default Basket;
